import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import Crypto from './Crypto';
import Documentation from './Documentation';
import DefaultPages from './DefaultPages';
import Account from './Account';
import ECommerce from './ECommerce';
import Maps from './Maps';
import Charts from './Charts';
import Tables from './Tables';
import Forms from './Forms';
import UI from './UI';

import Chat from '../../../Chat/index';
import Todo from '../../../Todo/index';

import FitnessDashboard from '../../../Dashboards/Fitness/index';
import DefaultDashboard from '../../../Dashboards/Default/index';
import MobileAppDashboard from '../../../Dashboards/MobileApp/index';
import BookingDashboard from '../../../Dashboards/Booking/index';

import Mail from '../../../Mail/index';
import Target from './Target';
import Customers from './Customers';
import Blasts from './Blasts';
import BlackList from './BlackList';
import Bets from './Bets';
import Reports from './Reports';
import Finance from './Finance';
import users from './users';
import { FAQs } from '../../../FAQs/faq';
import { CustomersWithdrwals } from '../../../Finance/customerwithdraws';
import { Transaction } from '../../../Finance/transaction';
import { DepositRequests } from '../../../Finance/depositrequests';
import { Transaction_Customer } from '../../../Finance/transaction_customer';
import { DepositRequests_Customer } from '../../../Finance/depositrequests_customer';
import { QueeMessages } from '../../../Blasts/bulksms';
import { PresentersDeposits } from '../../../Finance/presenters';
import { NewlyCustomersCount } from '../../../Finance/perday';
import { DepositPresenters } from '../../../Finance/depositperday_presenters';
import { WithdrawPresenters } from '../../../Finance/depositperday_withdraw';
import { SMSPresenters } from '../../../Finance/sms_perday';


import { DrawWinnerPresenter } from '../../../Finance/drawwinnerpresenter';
import { WinnerSelectPresenter } from '../../../Finance/winnerselectpresenter';
import FileUploadDefaultTiho from '../../../CSV/components/FileUploadDefaultTiho';

export default () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/dashboard_default" component={DefaultDashboard} />
      <Route path="/dashboard_e_commerce" component={Commerce} />
      <Route path="/dashboard_fitness" component={FitnessDashboard} />
      <Route path="/dashboard_crypto" component={Crypto} />
      <Route exact path="/dashboard_mobile_app" component={MobileAppDashboard} />
      <Route path="/dashboard_booking" component={BookingDashboard} />
      <Route path="/ui" component={UI} />
      <Route path="/target" component={Target} />
      <Route path="/termscon" component={FAQs} />
      <Route path="/mail" component={Mail} />
      <Route path="/chat" component={Chat} />
      <Route path="/todo" component={Todo} />
      <Route path="/forms" component={Forms} />
      <Route path="/withdrawals_customer" component={Transaction_Customer} />
      <Route path="/deposits_customer" component={DepositRequests_Customer} />

      <Route path="/default_tigo" component={FileUploadDefaultTiho} />
      
      <Route path="/tables" component={Tables} />
      <Route path="/charts" component={Charts} />
      <Route path="/maps" component={Maps} />
      <Route path="/account" component={Account} />
      <Route path="/customers" component={Customers} />
      <Route path="/customers-withdrawals" component={CustomersWithdrwals} />
      <Route path="/transaction" component={Transaction} />
   
      <Route path="/DepositRequests" component={DepositRequests} />
   
      <Route path="/bulksms" component={QueeMessages} />


      
      <Route path="/countdd" component={NewlyCustomersCount} />

      <Route path="/presenters" component={PresentersDeposits} />
      
      <Route path= "/presenter_deposits" component={DepositPresenters} />
      
      <Route path= "/presenter_withdrawals" component={WithdrawPresenters} />

      <Route path= "/sms_presenters" component={SMSPresenters} />



      <Route path= "/draw_presenters" component={DrawWinnerPresenter} />


      <Route path= "/presenter_winner" component={WinnerSelectPresenter} />

      
      
      <Route path="/blasts" component={Blasts} />
      <Route path="/" component={BlackList} />
      <Route path="/" component={Bets} />
      <Route path="/" component={Reports} />
      <Route path="/" component={Finance} />
      <Route path="/" component={users} />
      <Route path="/e-commerce" component={ECommerce} />
      <Route path="/default_pages" component={DefaultPages} />
      <Route path="/documentation" component={Documentation} />
    </div>
  </div>
);
